import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Tools|Exams Under Review|';

type LocNameStart = 'SPToolsExamsUnderReview';
export type SPToolsExamsUnderReviewLocNames =
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelRequirement`
	| `${LocNameStart}LabelDaysInQueue`
	| `${LocNameStart}LabelUpdated`;

export const spToolsExamsUnderReviewLocs: LocDefs<SPToolsExamsUnderReviewLocNames> = {
	SPToolsExamsUnderReviewTitlePage: {
		defaultValue: 'Other Requirements Pending Review',
		description: 'Page Title',
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName: 'Tools/Tools.OtherRequirementsUnderReview.Title.PageTitle',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.Tools,
		portal: 'SP',
	},
	SPToolsExamsUnderReviewLabelName: {
		defaultValue: 'Name',
		description: 'Column heading for: Name.',
		displayPath: `${pathStart}Name`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Tools.OtherRequirementsUnderReview.ColumnHeading.Name',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.OtherRequirement,
		portal: 'SP',
	},
	SPToolsExamsUnderReviewLabelRequirement: {
		defaultValue: 'Requirement',
		description: 'Column heading for: Requirement.',
		displayPath: `${pathStart}Requirement`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Tools.OtherRequirementsUnderReview.ColumnHeading.Requirement',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.OtherRequirement,
		portal: 'SP',
	},
	SPToolsExamsUnderReviewLabelDaysInQueue: {
		defaultValue: 'Days in Queue',
		description: 'Column heading for: Days in Queue.',
		displayPath: `${pathStart}Days in Queue`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Tools.OtherRequirementsUnderReview.ColumnHeading.DaysInQueue',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.OtherRequirement,
		portal: 'SP',
	},
	SPToolsExamsUnderReviewLabelUpdated: {
		defaultValue: 'Updated',
		description: 'Column heading for: Updated.',
		displayPath: `${pathStart}Updated`,
		displayType: 'Label',
		legacyName: 'OtherRequirement/Tools.OtherRequirementsUnderReview.ColumnHeading.Updated',
		shared: false,
		htmlAllowed: false,
		feature: HubFeature.OtherRequirement,
		portal: 'SP',
	},
};

export type SPToolsExamsUnderReviewLocType = LocMap<SPToolsExamsUnderReviewLocNames>;
